export default __webpack_public_path__ + "static/media/AP.e097e832.svg";